// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"bfeb70b9","389":"ac9d97da","823":"e9e33999"}[chunkId] + ".js";
};